/* eslint-disable no-underscore-dangle */
import React from "react";

const CartaoDia = (props) => {
  const dia = props.dia._d;
  const data = new Date(props.ano, props.indice, 1);

  const editarFacultativo = (item) => {
    if (item && item.sequencialPontoFacultativo) {
      props.history.push({
        pathname: `${props.match.url}/form`,
        state: {
          sequencialPontoFacultativo: item.sequencialPontoFacultativo,
          dataPontoFacultativo: item.dataPontoFacultativo,
          descricaoPontoFacultativo: item.descricaoPontoFacultativo,
          sequencialUf: item.sequencialUf,
          sequencialMunicipio: item.sequencialMunicipio,
        },
      });
    }
  };

  const novoFacultativo = (dataFacultativo) => {
    if (dataFacultativo) {
      props.history.push({
        pathname: `${props.match.url}/form`,
        state: {
          sequencialPontoFacultativo: "",
          dataPontoFacultativo: dataFacultativo,
          descricaoPontoFacultativo: "",
          sequencialUf: "",
          sequencialMunicipio: "",
        },
      });
    }
  };

  if (dia.getMonth() !== data.getMonth()) {
    return (
      <div id="" className="cartao-dia foraMes">
        {props.dia.format("DD").toString()}
      </div>
    );
  }

  if (props.dataSelecionada.find((valor) => valor.getTime() === dia.getTime())) {
    return (
      <div id="" className="cartao-dia selecionada">
        {props.dia.format("DD").toString()}
      </div>
    );
  }

  const facultativo = props.facultativos.find(
    (valor) => new Date(valor.dataPontoFacultativo).getTime() === dia.getTime(),
  );
  if (facultativo) {
    return (
      <div
        id=""
        className="cartao-dia facultativo"
        title={`PONTO FACULTATIVO: ${facultativo.descricaoPontoFacultativo}`}
        onClick={() => editarFacultativo(facultativo)}
      >
        {props.dia.format("DD").toString()}
      </div>
    );
  }

  const feriado = props.feriados.find((valor) => new Date(valor.dataPontoFacultativo).getTime() === dia.getTime());
  if (feriado) {
    return (
      <div id="" className="cartao-dia feriado" title={`FERIADO: ${feriado.descricaoPontoFacultativo}`}>
        {props.dia.format("DD").toString()}
      </div>
    );
  }

  const diaSemana = new Date(dia.getTime()).getDay();
  if (diaSemana === 0 || diaSemana === 6) {
    return (
      <div id="" className="cartao-dia fim-semana">
        {props.dia.format("DD").toString()}
      </div>
    );
  }

  return (
    <div
      id=""
      className="cartao-dia"
      onClick={() => novoFacultativo(new Date(dia.getTime()).toISOString().slice(0, 10))}
    >
      {props.dia.format("DD").toString()}
    </div>
  );
};

export default CartaoDia;
